import * as core from '../../../../../../../core'

import { query } from './communications-needed-by-workstream.query'

export const RESOURCE = {
  payload: {
    alias: 'communications.needed.by.workstream',
    description: 'Chart view of communications needed by workstream',
    name: 'Communications Needed by Workstream',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
